import React from 'react';

import {Icon, Text} from '@albert-io/atomic';
import classNames from 'classnames';

import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface SchoolTypeCardProps {
  icon: IconProp;
  label: string;
  selected: boolean;
  onClick: () => void;
}

export default function SchoolTypeCard({icon, label, selected, onClick}: SchoolTypeCardProps) {
  return (
    <button
      type='button'
      className={classNames(
        'flex flex-1 cursor-pointer flex-col items-center justify-center gap-x1-half rounded-[12px] p-x1-half transition-colors',
        'h-[100px]',
        {
          'border-2 border-selected background-brand-subtle': selected,
          'border border-primary background-primary': !selected
        }
      )}
      onClick={onClick}
      aria-pressed={selected}
    >
      <Icon className='h-[34px]' icon={icon} color={selected ? 'brand' : 'primary'} />
      <Text bold color={selected ? 'brand' : 'primary'}>
        {label}
      </Text>
    </button>
  );
}
